// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".acc-fade-enter-active[data-v-66147b5c],.acc-fade-leave-active[data-v-66147b5c]{transition:opacity .16s ease,transform .16s ease}.acc-fade-enter[data-v-66147b5c],.acc-fade-leave-to[data-v-66147b5c]{opacity:0;transform:translateY(6px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
